import { Blockchain } from "@rarible/api-client"
import { arenaz } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const arenazConfig: StaticEthereumBlockchainConfig = {
  name: "Arena-Z",
  icon: "/images/blockchains/arenaz.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://arenaz-api.rarible.org",
  chainId: arenaz.id,
  blockchain: Blockchain.ARENAZ,
  chainName: "Arena-Z",
  exchange: {
    v2: "0x3F246Dfcc7DA7B4f2796b69c2A520162961eFd3a",
    wrapper: "0x8765C39d67F3921Eb5604559b9F38dFa0cD855b7",
  },
  transferProxies: {
    nft: "0x12181eDedD1f81838580668bb5B50e1030df4667",
    erc721Lazy: "0x5C938272c3305f40691B584E1243c30118640cCB",
    erc20: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
  },
  blockExplorers: [
    {
      url: "https://explorer.arena-z.gg",
      icon: "/images/scanner.svg",
      adress: "https://explorer.arena-z.gg/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "arenaz-node",
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("ARENAZ:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "ETH",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ARENAZ:0x4200000000000000000000000000000000000006"),
    symbol: "WETH",
    name: "WETH",
    decimals: 18,
  },
  addFundsLink: "https://bridge.arena-z.gg/",
  hasStabilityProtocol: true,
  viem: arenaz,
}

export const getArenaZConfig = (): StaticEthereumBlockchainConfig =>
  arenazConfig
